export default __webpack_public_path__ + "static/media/navbar-statistics-hlr-dark.b3859d68.svg";